import React from "react";
import Typography from "@material-ui/core/Typography";
import { FormattedMessage } from "react-intl";
import Card from "components/card";
import Icon from "components/icon";
import withStyles from "components/with-styles";
import styles from "./styles/no-data.css.js";

const NoData = ({ classes, noDataMessage = "app.noData" }) => (
  <Card classes={classes}>
    <Icon color="disabled" name="list" />
    <Typography variant="body1">
      <FormattedMessage id={noDataMessage} />
    </Typography>
  </Card>
);

export default withStyles(styles)(NoData);
